var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.37842 28L22 49L41.6217 28","stroke":"black","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M22 49L22 1.66893e-06","stroke":"black","strokeWidth":"4","key":1})]);
}

ArrowDown.defaultProps = {"width":"44","height":"52","viewBox":"0 0 44 52","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
